<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step class="cursor-pointer" @click="e1 = 1" :complete="e1 > 1" step="1">داشبورد</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="cursor-pointer" @click="e1 = 2" :complete="e1 > 2" step="2"> ایجاد اعلام بار</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="cursor-pointer" @click="e1 = 3" :complete="e1 > 3" step="3"> شارژ حساب </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="cursor-pointer" @click="e1 = 4" step="4"> تیکت ها و کاربران </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
            <div class="flex flex-col mb-5">
                <p>صفحه داشبورد و راهنمای ان</p>
                <VRow>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img1.png" alt="">
                        </div>
                    </VCol>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img2.png" alt="">
                        </div>
                    </VCol>
                </VRow>
            </div>


          <v-btn color="primary" @click="e1 = 2"> بعدی </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">

            <div class="space-y-3">
                <p>در قسمت ایجاد اعالم بار سه مرحله است که بصورت زیر بایستی تکمیل گردد.</p>
                <p>بخش اول: وارد کردن اطالعات محموله و نوع بسته بندی و نوع اعالم بار (نوع اعالم بار می تواند تعدادی و یا حجمی بر اساس کیلوگرم با</p>
                <p>بخش دوم: وارد کردن اطالعات آدرس مبدا و مقصد و مشخصات فرستنده و گیرنده کالا و مشخص کردن محل بارگیری و تخلیه روی نقشه است که این گزینه
کمک بزرگی به پیدا کردن راننده میکند</p>
                <p>بخش سوم : وارد کردن مشخصات نوع ناوگان مورد نیاز و کرایه و توضیحات است.</p>
                <VRow>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img3.png" alt="">
                        </div>
                    </VCol>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img4.png" alt="">
                        </div>
                    </VCol>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img5.png" alt="">
                        </div>
                    </VCol>
                </VRow>
            </div>

          <v-btn color="primary" @click="e1 = 3"> بعدی </v-btn>
          <v-btn @click="e1 = 1"> برگشت </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">

            <div class="space-y-3">
                <p>برای افزایش موجودی از قسمت مالی->شارژ حساب استفاده و با پر کردن فیلد مقدار به ریال و زدن دکمه درخواست فاکتور پرداخت فاکتور به لیست شارژ
های حساب افزوده می شود . سپس با زدن دکمه پرداخت و ورود به درگاه اینترنتی پرداخت می توانید فاکتور خود را پرداخت نمائید</p>
                <VRow>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img6.png" alt="">
                        </div>
                    </VCol>
                </VRow>
            </div>

          <v-btn color="primary" @click="e1 = 4"> بعدی </v-btn>
          <v-btn @click="e1 = 2"> برگشت </v-btn>
        </v-stepper-content>


        <v-stepper-content step="4">
        <div class="space-y-3">
            <p>تیکت ها</p>
            <p>برای ارتباط با واحد پشتیبانی می توانند از قسمت تیکت ها اقدام به ارسال تیکت و مشاهده تیکت ها وبررسی آن نمایند.</p>
            <p>همچنین با کلیک بر روی گزینه مشاهده میتوانید وضعیت و پیامهای رد و بدل شده با ادمین را نیز مشاهده کنید.از گوشه سمت راست پایین می توانید بصورت
آنلاین با کاربران پشتیبانی چت کنید</p>
                <VRow>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img7.png" alt="">
                        </div>
                    </VCol>
                    <VCol cols="12">
                        <div class="flex h-full bg-stone-50 items-center justify-center">
                            <img src="../../assets/guide/img8.png" alt="">
                        </div>
                    </VCol>
                </VRow>
        </div>
        <div class="space-y-3 mt-5">
            <p>کاربران</p>
            <p>ایجاد کاربر: برای ایجاد کاربر از منو قسمت مدیریت کاربران->ایجاد کاربر و پر کردن فرم کاربر جدید ایجاد و دسترسی های الزم برای اعالم بار و ... را به کاربر تخصیص می دهید.</p>
            <VRow>
                <VCol cols="12">
                    <div class="flex h-full bg-stone-50 items-center justify-center">
                        <img src="../../assets/guide/img9.png" alt="">
                    </div>
                </VCol>
            </VRow>
            <p>لیست کاربران: مشاهده کاربران شرکت وفعال وغیر فعال کردن آنها</p>
            <VRow>
                <VCol cols="12">
                    <div class="flex h-full bg-stone-50 items-center justify-center">
                        <img src="../../assets/guide/img10.png" alt="">
                    </div>
                </VCol>
            </VRow>

        </div>

          <v-btn color="primary" @click="$emit('closeModal'), e1 = 1"> بستن </v-btn>
          <v-btn @click="e1 = 3"> برگشت </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>

export default {
    data() {
        return {
            e1: 1,
        }
    },
};
</script>

<style scoped></style>
